import React from "react";

const ReadOnlyRow = ({ contact, handleEditClick, handleDeleteClick }) => {
  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Get color class for holiday type
  const getTypeColorClass = (type) => {
    const colors = {
      "National Holiday": "badge bg-danger",
      Festival: "badge bg-purple",
      "Religious Holiday": "badge bg-info",
      "Company Holiday": "badge bg-success",
    };
    return colors[type] || "badge bg-secondary";
  };

  return (
    <tr>
      <td>{contact.holiday_name || "-"}</td>
      <td>{formatDate(contact.holiday_date)}</td>
      <td>{contact.holiday_day || "-"}</td>
      <td>
        <span className={getTypeColorClass(contact.holiday_type)}>
          {contact.holiday_type || "-"}
        </span>
      </td>
      <td style={{ textAlign: "center" }}>
        <div className="d-flex gap-2 justify-content-center">
          <button
            className="btn btn-sm btn-transparent"
            style={{}}
            type="button"
            onClick={(event) => handleEditClick(event, contact)}
            title="Edit"
          >
            <i className="bi bi-pencil"></i>
          </button>
          <button
            className="btn btn-sm btn-transparent"
            style={{}}
            type="button"
            onClick={() => handleDeleteClick(contact.id)}
            title="Delete"
          >
            <i className="bi bi-trash text-danger"></i>
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ReadOnlyRow;
